/*@flow*/
import type { ContextT } from './types';

export default (ctx: ContextT): {|set: (path: string, value: any) => void|} => ({
  set(path: string, value: any) {
    ctx.dispatch({
      type: 'SET_RECORD',
      payload: { path, value },
    });
  },
});
